"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILTERS_NAMES = void 0;
var FILTERS_NAMES = ['filters', 'locations', 'sublocations', 'dates', 'startTime', 'endTime', 'count', 'offset', 'speakers', 'sessionsIds'];
exports.FILTERS_NAMES = FILTERS_NAMES;